import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const DocumentCheckIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props} sx={{ fill: 'transparent', ...props.sx }}>
            <path
                d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M16 13H8M16 17H8M10 9H8M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
                stroke="currentColor"
                strokeWidth="1.333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle
                cx="17"
                cy="19"
                r="5.55532"
                fill="#008866"
                stroke="white"
                strokeWidth="1.11065"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.0234 19.188L16.2273 20.3919L16.2195 20.3841L18.9357 17.668"
                fill="#008866"
            />
            <path
                d="M15.0234 19.188L16.2273 20.3919L16.2195 20.3841L18.9357 17.668"
                stroke="white"
                strokeWidth="0.832986"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

export default DocumentCheckIcon;
